/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useState } from 'react';
import { NavLink, useParams, useHistory } from 'react-router-dom';
import { Row, Col, Card, Button, Accordion, useAccordionButton } from 'react-bootstrap';
import HtmlHead from 'components/html-head/HtmlHead';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
// external
import ReactPlayer from 'react-player/lazy';
// redux
import { useSelector } from 'react-redux';
// utils
import LoadingCar from '../../../../components/loading/LoadingCar';

const Template = () => {
  const title = 'Shopify';
  const description = 'Shopify Integraciones Autopaquete';
  const { plugin } = useParams();
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [info, setInfo] = useState({});
  const [questions, setQuestions] = useState([]);
  const { currentUser } = useSelector((state) => state.auth);
  const history = useHistory();
  function CustomAccordionToggle({ children, eventKey }) {
    const decoratedOnClick = useAccordionButton(eventKey, () => {});

    return (
      <Card.Body className="py-4" onClick={decoratedOnClick} role="button">
        <Button variant="link" className="list-item-heading p-0">
          {children}
        </Button>
      </Card.Body>
    );
  }
  const handleInstall = (resource) => {
    if (resource.startsWith('http')) {
      // Es una URL, redirige a la página
      window.open(resource, '_blank');
    } else {
      // Es un archivo en base64, descarga el contenido
      const fileName = 'archivo.zip'; // Cambia esto si el nombre varía
      const link = document.createElement('a');
      link.href = `data:application/zip;base64,${resource}`;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem('localIntegrationsState'));
    if (!storedData.pluginsInfo) {
      history.push('/integraciones/documentacion');
    }
    if (storedData.pluginsInfo) {
      setIsInitialLoading(false);
      const pluginInfo = storedData.pluginsInfo?.filter((item) => item.name === plugin);
      setInfo({
        description: pluginInfo[0].description,
        status: pluginInfo[0].is_active ? 'active' : 'inactive',
        plugin: pluginInfo[0].name,
        img: pluginInfo[0].service_img_with_base_url,
        url: pluginInfo[0].plugins_versions[0].url,
        urlDemoVideo: pluginInfo[0].url_video,
        urlSetUpVideo: pluginInfo[0].url_video_setup,
        resource: pluginInfo[0].plugins_versions[0].resource,
      });
      setQuestions(pluginInfo[0].plugins_faqs);
    }
  }, []);

  return (
    <>
      {isInitialLoading && <LoadingCar />}
      <div id="pageContainer">
        <HtmlHead title={title} description={description} />
        <div className="page-title-container">
          <Row className="g-0 mb-5">
            {/* Title Start */}
            <Col className="col-auto mb-3 mb-sm-0 me-auto">
              <NavLink className="muted-link pb-1 d-inline-block hidden breadcrumb-back" to="/integraciones/documentacion">
                <CsLineIcons icon="chevron-left" size="13" />
                <span className="align-middle text-small ms-1">Atrás</span>
              </NavLink>
              <h1 className="mb-0 pb-0 display-4" id="title">
                {info.plugin}
              </h1>
            </Col>
            {/* Title End */}
          </Row>
          <Row>
            {/* Introduction Banner Start */}
            <Col lg="8" className="mb-5">
              <Card className="sh-45 h-lg-100 position-relative bg-theme">
                <img src={info.img} className="card-img h-100 position-absolute" alt="card image" />
                {/* <img src="/img/illustration/database.webp" className="card-img h-100 position-absolute theme-filter" alt="card image" /> */}
                <div className="card-img-overlay d-flex flex-column justify-content-end bg-transparent">
                  <div className="mb-4">
                    <div className="cta-1 mb-2 w-75 w-sm-50">{`Integra tu tienda de ${info.plugin}`}</div>
                    <div className="w-50 text-alternate">{info.description}</div>
                  </div>
                  <div>
                    <Button variant="primary" onClick={() => handleInstall(info.resource)}>
                      <CsLineIcons icon="chevron-right" />
                      <span>Instalar</span>
                    </Button>
                  </div>
                </div>
              </Card>
            </Col>
            {/* Introduction Banner End */}
            {/* Introduction List Start */}
            <Col lg="4" className="mb-5">
              <Card className="mb-2">
                <Row className="g-0 sh-9">
                  <Col xs="auto">
                    <div className="sw-9 sh-9 d-inline-block d-flex justify-content-center align-items-center">
                      <div className="fw-bold text-primary">
                        <CsLineIcons icon="download" />
                      </div>
                    </div>
                  </Col>
                  <Col>
                    <Card.Body className="d-flex flex-column p-0 pe-4 h-100 justify-content-center">
                      <div className="d-flex flex-column">
                        Fácil Instalación
                        <div className="text-small text-muted text-truncate">Instala desde la Shopify App Store.</div>
                      </div>
                    </Card.Body>
                  </Col>
                </Row>
              </Card>
              <Card className="mb-2">
                <Row className="g-0 sh-9">
                  <Col xs="auto">
                    <div className="sw-9 sh-9 d-inline-block d-flex justify-content-center align-items-center">
                      <div className="fw-bold text-primary">
                        <CsLineIcons icon="box" />
                      </div>
                    </div>
                  </Col>
                  <Col>
                    <Card.Body className="d-flex flex-column p-0 pe-4 h-100 justify-content-center">
                      <div className="d-flex flex-column">
                        Gestión Eficiente de Envíos
                        <div className="text-small text-muted text-truncate">Genera guías, cotiza envíos y optimiza paquetes.</div>
                      </div>
                    </Card.Body>
                  </Col>
                </Row>
              </Card>
              <Card className="mb-2">
                <Row className="g-0 sh-9">
                  <Col xs="auto">
                    <div className="sw-9 sh-9 d-inline-block d-flex justify-content-center align-items-center">
                      <div className="fw-bold text-primary">
                        <CsLineIcons icon="settings-1" />
                      </div>
                    </div>
                  </Col>
                  <Col>
                    <Card.Body className="d-flex flex-column p-0 pe-4 h-100 justify-content-center">
                      <div className="d-flex flex-column">
                        Intuitiva y Fácil de Usar
                        <div className="text-small text-muted text-truncate">Gestiona envíos sin complicaciones.</div>
                      </div>
                    </Card.Body>
                  </Col>
                </Row>
              </Card>
              {/* className="hover-border-primary" */}
              <Card>
                <Row className="g-0 sh-9">
                  <Col xs="auto">
                    <div className="sw-9 sh-9 d-inline-block d-flex justify-content-center align-items-center">
                      <div className="fw-bold text-primary">
                        <CsLineIcons icon="web-page" />
                      </div>
                    </div>
                  </Col>
                  <Col>
                    <Card.Body className="d-flex flex-column p-0 pe-4 h-100 justify-content-center">
                      <div className="d-flex flex-column">
                        Gestión centralizada
                        <div className="text-small text-muted text-truncate">Controla envíos y mantén tu marca consistente.</div>
                      </div>
                    </Card.Body>
                  </Col>
                </Row>
              </Card>
            </Col>
            {/* Introduction List End */}
          </Row>
          <Row>
            {/* Access Token End */}

            {/* Access Token Start */}
            <Col lg="6" className="mb-5">
              <h2 className="small-title">Instalación rápida en minutos</h2>
              <Card className="h-100-card sh-45 bg-infox cover overflow-hidden">
                <ReactPlayer url={info.urlDemoVideo} controls width="100%" height="100%" />
              </Card>
            </Col>
            <Col lg="6" className="mb-5">
              <h2 className="small-title">Cómo hacer tu primer envío</h2>
              <Card className="h-100-card sh-45 bg-infox cover overflow-hidden">
                <ReactPlayer url={info.urlSetUpVideo} controls width="100%" height="100%" />
              </Card>
            </Col>
            {/* Access Token End */}
          </Row>
          <Row>
            <Col>
              {/* Accordion Cards Start */}
              <section className="scroll-section" id="accordionCards">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h2 className="small-title">Preguntas frecuentes</h2>
                  <Button
                    className="mt-5 text-end"
                    variant="primary"
                    onClick={() =>
                      window.open(
                        `https://wa.me/+5213323381992/?text=${encodeURIComponent(
                          `Hola, me comunico de la cuenta ${currentUser.crmId}. Necesito ayuda con la integración de Shopify, ¿me podrías apoyar, por favor?`
                        )}`
                      )
                    }
                  >
                    Contactar soporte
                  </Button>
                </div>
                <Accordion className="mb-n2" defaultActiveKey="1">
                  {questions.map((item) => (
                    <Card key={item.id} className="d-flex mb-2 flex-grow-1">
                      <CustomAccordionToggle eventKey={item.id}>
                        <p className="text-wrap text-start">{item.question}</p>
                      </CustomAccordionToggle>
                      <Accordion.Collapse eventKey={item.id}>
                        <Card.Body className="pt-0">
                          <p>{item.answer}</p>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  ))}
                </Accordion>
              </section>
              {/* Accordion Cards End */}
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
export default Template;
